// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "../javascript/controllers/application"

import AccordionComponentController from "./accordion_component_controller"
application.register("accordion-component", AccordionComponentController)

import DetailedModalComponent__DetailedModalComponentController from "./detailed_modal_component/detailed_modal_component_controller"
application.register("detailed-modal-component", DetailedModalComponent__DetailedModalComponentController)

import DetailsComponentController from "./details_component_controller"
application.register("details-component", DetailsComponentController)

import ExpansionPanelComponentController from "./expansion_panel_component_controller"
application.register("expansion-panel-component", ExpansionPanelComponentController)

import FrontChatComponentController from "./front_chat_component/front_chat_component_controller"
application.register("front-chat-component", FrontChatComponentController)

import OptionsFieldsetComponent__OptionsFieldsetComponentController from "./options_fieldset_component/options_fieldset_component_controller"
application.register("options-fieldset-component", OptionsFieldsetComponent__OptionsFieldsetComponentController)
